<div id="signin-btn-container" *ngIf="!userIsSignedIn">
  <button id="signin-btn" (click)="signIn()">
    <i class="fa fa-user-circle-o" aria-hidden="true"></i>
    <span>Sign in</span>
  </button>
</div>
